import { newToolFilterOAuthMcp } from "../oauth.ts";

export const huggingFaceMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://huggingface.co/datasets/huggingface/brand-assets/resolve/main/hf-logo.svg",
  // `login` makes the server demand OAuth instead of falling back to the
  // anonymous tool set; `gradio=none` drops the user-configured Gradio Space
  // tools, so the server exposes only built-in tools.
  url: "https://huggingface.co/mcp?login&gradio=none",
  label: "Hugging Face",
});
